export const on = <E extends keyof WindowEventMap>(
  type: E,
  listener: (this: Window, ev: WindowEventMap[E]) => any,
  useCapture?: boolean,
) => {
  window.addEventListener(type, listener, useCapture);
  return () => window.removeEventListener(type, listener, useCapture);
};
